import { IoWifiSharp } from "react-icons/io5";
import { IoMdPower } from "react-icons/io";
import { FaFlag } from "react-icons/fa6";
import { PiFlagPennantFill } from "react-icons/pi";

const QuizBodyFooter = () => {
  return (
    <>
      <section>
        <div className="mt-4 p-3 rounded bg-default-2 shadow-sm">
          <h5 className="text-primary">📌 Instructions</h5>
          <ul className="text-muted text-start p-3">
            <li>Read the question carefully.</li>
            <li>Select the correct option by clicking on it.</li>
            <li>You can flag questions to review them later.</li>
            <li>Click "Submit" when you're done.</li>
          </ul>
        </div>
      </section>
    </>
  );
}
export default QuizBodyFooter;